import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen } from 'lucide-react';
import OrnateDivider from '../components/OrnateDivider';

const Books = () => {
  return (
    <div className="min-h-screen mystical-bg pt-32 pb-24 relative" data-testid="books-coming-soon">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          <OrnateDivider label="Sacred Library" variant="lotus" className="mb-8 max-w-md mx-auto" />

          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full border border-primary/40 bg-primary/5 mb-8">
            <BookOpen className="w-8 h-8 text-primary/80" />
          </div>

          <h1 className="text-4xl md:text-6xl font-heading font-medium tracking-wider golden-text text-glow mb-5">
            Coming Soon
          </h1>

          <p className="text-base md:text-lg text-primary/75 max-w-xl mx-auto leading-relaxed mb-3">
            A curated collection of books on Himalayan Siddha Tantra, Yoga and
            lineage-rooted sadhana is being prepared.
          </p>
          <p className="text-sm text-primary/55 italic">
            Namo Adesh. Please return soon.
          </p>

          <OrnateDivider variant="diamond" className="mt-12 max-w-sm mx-auto" />
        </motion.div>
      </div>
    </div>
  );
};

export default Books;
